module.exports = __webpack_public_path__ + "static/media/newsletter-december-2023-2.5f43ea98.jpg";